import React from "react";
import { NavLink } from "react-router-dom";
import Switcher from "../Elements/Switcher";

var bnr = require("./../../images/background/bg-footer.png");

class Footer2 extends React.Component {
  render() {
    return (
      <>
        <footer className="site-footer footer-large footer-dark footer-wide">
          {/* FOOTER BLOCKES START */}
          <div
            className="footer-top overlay-wraper bg-cover"
            style={{ backgroundImage: "url(" + bnr + ")" }}
          >
            <div className="overlay-main  " />
            <div className="container">
              <div className="row">
                {/* ABOUT COMPANY */}
                <div className="col-lg-4 col-md-6 col-sm-6">
                  <div className="widget widget_about">
                    {/*<h4 class="widget-title">About Company</h4>*/}
                    <div className="logo-footer clearfix p-b15">
                      <NavLink to={"./"}>
                        <img
                          src={require("./../../images/footer-white.png")}
                          alt="Sunlight Creationz"
                        />
                      </NavLink>
                    </div>
                    {/* <p>7X Theme is a html template for interior and architecture purpose. Today we can tell you, thanks to your passion.</p> */}
                    <ul className="social-icons sx-social-links">
                      {/* <li><a href="https://www.behance.net/" className="fa-brands fa-behance" target="_blank"></a></li>
                                            <li><a href="https://www.facebook.com" className="fa-brands fa-facebook" target="_blank"></a></li> */}
                      {/* <li><a href="https://twitter.com" className="fa-brands fa-twitter" target="_blank"></a></li> */}
                      <li className="ml-5">
                        <a
                          href="https://www.tiktok.com/@sunlightcreationz?_t=8roDYxOkezY&_r=1"
                          className="fa-brands fa-tiktok"
                          target="_blank"
                        ></a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com"
                          className="fa-brands fa-instagram"
                          target="_blank"
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-sm-6 footer-col-3">
                  <div className="widget widget_services inline-links">
                    <h5 className="widget-title">Our Services</h5>
                    <ul>
                      <li>
                        <NavLink to={"/services/Receptions"}>
                          Receptions
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to={"/services/Weddings"}>Weddings</NavLink>
                      </li>
                      <li>
                        <NavLink to={"/services/Home-Decor"}>
                          Home Decor
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to={"/services/Pre-Wedding"}>
                          Pre-Wedding
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to={"/rentals"}>Rentals</NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* CONTACT US */}
                <div className="col-lg-4 col-md-6 col-sm-6">
                  <div className="widget widget_address_outer">
                    <h5 className="widget-title">Contact Us</h5>
                    <ul className="widget_address">
                      {/* <li>756 Livingston Street, Brooklyn, NY 11201, United State</li> */}
                      <li>info@sunlightcreationz.com</li>
                      {/* <li>(+298) 012-3456-789</li> */}
                      {/* <li>(+298) 146-6543-480</li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* FOOTER COPYRIGHT */}
          <div className="footer-bottom overlay-wraper">
            <div className="overlay-main" />
            <div className="container">
              <div className="row">
                <div className="sx-footer-bot-center">
                  <span className="copyrights-text">
                    © 2024 Sunlight Creationz. Designed By TechHive.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <Switcher />
      </>
    );
  }
}

export default Footer2;
